export interface Country {
  name: string;
  code: string;
  flag: string;
  phoneCode: string;
}

export const countries: Country[] = [
  { name: 'Afghanistan', code: 'AF', flag: '🇦🇫', phoneCode: '+93' },
  { name: 'Albania', code: 'AL', flag: '🇦🇱', phoneCode: '+355' },
  { name: 'Algeria', code: 'DZ', flag: '🇩🇿', phoneCode: '+213' },
  { name: 'Argentina', code: 'AR', flag: '🇦🇷', phoneCode: '+54' },
  { name: 'Australia', code: 'AU', flag: '🇦🇺', phoneCode: '+61' },
  { name: 'Austria', code: 'AT', flag: '🇦🇹', phoneCode: '+43' },
  { name: 'Bangladesh', code: 'BD', flag: '🇧🇩', phoneCode: '+880' },
  { name: 'Belgium', code: 'BE', flag: '🇧🇪', phoneCode: '+32' },
  { name: 'Brazil', code: 'BR', flag: '🇧🇷', phoneCode: '+55' },
  { name: 'Bulgaria', code: 'BG', flag: '🇧🇬', phoneCode: '+359' },
  { name: 'Canada', code: 'CA', flag: '🇨🇦', phoneCode: '+1' },
  { name: 'Chile', code: 'CL', flag: '🇨🇱', phoneCode: '+56' },
  { name: 'China', code: 'CN', flag: '🇨🇳', phoneCode: '+86' },
  { name: 'Colombia', code: 'CO', flag: '🇨🇴', phoneCode: '+57' },
  { name: 'Croatia', code: 'HR', flag: '🇭🇷', phoneCode: '+385' },
  { name: 'Czech Republic', code: 'CZ', flag: '🇨🇿', phoneCode: '+420' },
  { name: 'Denmark', code: 'DK', flag: '🇩🇰', phoneCode: '+45' },
  { name: 'Egypt', code: 'EG', flag: '🇪🇬', phoneCode: '+20' },
  { name: 'Finland', code: 'FI', flag: '🇫🇮', phoneCode: '+358' },
  { name: 'France', code: 'FR', flag: '🇫🇷', phoneCode: '+33' },
  { name: 'Germany', code: 'DE', flag: '🇩🇪', phoneCode: '+49' },
  { name: 'Greece', code: 'GR', flag: '🇬🇷', phoneCode: '+30' },
  { name: 'Hungary', code: 'HU', flag: '🇭🇺', phoneCode: '+36' },
  { name: 'India', code: 'IN', flag: '🇮🇳', phoneCode: '+91' },
  { name: 'Indonesia', code: 'ID', flag: '🇮🇩', phoneCode: '+62' },
  { name: 'Iran', code: 'IR', flag: '🇮🇷', phoneCode: '+98' },
  { name: 'Iraq', code: 'IQ', flag: '🇮🇶', phoneCode: '+964' },
  { name: 'Ireland', code: 'IE', flag: '🇮🇪', phoneCode: '+353' },
  { name: 'Israel', code: 'IL', flag: '🇮🇱', phoneCode: '+972' },
  { name: 'Italy', code: 'IT', flag: '🇮🇹', phoneCode: '+39' },
  { name: 'Japan', code: 'JP', flag: '🇯🇵', phoneCode: '+81' },
  { name: 'Jordan', code: 'JO', flag: '🇯🇴', phoneCode: '+962' },
  { name: 'Kenya', code: 'KE', flag: '🇰🇪', phoneCode: '+254' },
  { name: 'Kuwait', code: 'KW', flag: '🇰🇼', phoneCode: '+965' },
  { name: 'Lebanon', code: 'LB', flag: '🇱🇧', phoneCode: '+961' },
  { name: 'Libya', code: 'LY', flag: '🇱🇾', phoneCode: '+218' },
  { name: 'Malaysia', code: 'MY', flag: '🇲🇾', phoneCode: '+60' },
  { name: 'Mali', code: 'ML', flag: '🇲🇱', phoneCode: '+223' },
  { name: 'Mexico', code: 'MX', flag: '🇲🇽', phoneCode: '+52' },
  { name: 'Morocco', code: 'MA', flag: '🇲🇦', phoneCode: '+212' },
  { name: 'Netherlands', code: 'NL', flag: '🇳🇱', phoneCode: '+31' },
  { name: 'New Zealand', code: 'NZ', flag: '🇳🇿', phoneCode: '+64' },
  { name: 'Niger', code: 'NE', flag: '🇳🇪', phoneCode: '+227' },
  { name: 'Nigeria', code: 'NG', flag: '🇳🇬', phoneCode: '+234' },
  { name: 'Norway', code: 'NO', flag: '🇳🇴', phoneCode: '+47' },
  { name: 'Pakistan', code: 'PK', flag: '🇵🇰', phoneCode: '+92' },
  { name: 'Peru', code: 'PE', flag: '🇵🇪', phoneCode: '+51' },
  { name: 'Philippines', code: 'PH', flag: '🇵🇭', phoneCode: '+63' },
  { name: 'Poland', code: 'PL', flag: '🇵🇱', phoneCode: '+48' },
  { name: 'Portugal', code: 'PT', flag: '🇵🇹', phoneCode: '+351' },
  { name: 'Qatar', code: 'QA', flag: '🇶🇦', phoneCode: '+974' },
  { name: 'Romania', code: 'RO', flag: '🇷🇴', phoneCode: '+40' },
  { name: 'Russia', code: 'RU', flag: '🇷🇺', phoneCode: '+7' },
  { name: 'Saudi Arabia', code: 'SA', flag: '🇸🇦', phoneCode: '+966' },
  { name: 'Senegal', code: 'SN', flag: '🇸🇳', phoneCode: '+221' },
  { name: 'Singapore', code: 'SG', flag: '🇸🇬', phoneCode: '+65' },
  { name: 'South Africa', code: 'ZA', flag: '🇿🇦', phoneCode: '+27' },
  { name: 'South Korea', code: 'KR', flag: '🇰🇷', phoneCode: '+82' },
  { name: 'Spain', code: 'ES', flag: '🇪🇸', phoneCode: '+34' },
  { name: 'Sudan', code: 'SD', flag: '🇸🇩', phoneCode: '+249' },
  { name: 'Sweden', code: 'SE', flag: '🇸🇪', phoneCode: '+46' },
  { name: 'Switzerland', code: 'CH', flag: '🇨🇭', phoneCode: '+41' },
  { name: 'Syria', code: 'SY', flag: '🇸🇾', phoneCode: '+963' },
  { name: 'Thailand', code: 'TH', flag: '🇹🇭', phoneCode: '+66' },
  { name: 'Tunisia', code: 'TN', flag: '🇹🇳', phoneCode: '+216' },
  { name: 'Turkey', code: 'TR', flag: '🇹🇷', phoneCode: '+90' },
  { name: 'Ukraine', code: 'UA', flag: '🇺🇦', phoneCode: '+380' },
  { name: 'United Arab Emirates', code: 'AE', flag: '🇦🇪', phoneCode: '+971' },
  { name: 'United Kingdom', code: 'GB', flag: '🇬🇧', phoneCode: '+44' },
  { name: 'United States', code: 'US', flag: '🇺🇸', phoneCode: '+1' },
  { name: 'Venezuela', code: 'VE', flag: '🇻🇪', phoneCode: '+58' },
  { name: 'Vietnam', code: 'VN', flag: '🇻🇳', phoneCode: '+84' },
  { name: 'Yemen', code: 'YE', flag: '🇾🇪', phoneCode: '+967' },
];

// Helper function to get phone code by country name
export const getPhoneCodeByCountry = (countryName: string): string => {
  const country = countries.find(c => c.name === countryName);
  return country?.phoneCode || '';
};

// Sort countries alphabetically by name
countries.sort((a, b) => a.name.localeCompare(b.name));
